module.exports = __webpack_public_path__ + "img/897-fe125c.png";